import { createFileRoute } from "@tanstack/react-router"
import { ApiError } from "@/api/client"
import type { ReportType } from "@/api/types"
import { TopicDetailPage } from "@/components/pages/mail/topics/detail/page"
import { TopicDetailSkeleton } from "@/components/pages/mail/topics/detail/skeleton"
import { NotFound } from "@/components/shared/errors/not-found"
import { Layout } from "@/components/shared/layout"
import { useReport } from "@/hooks/queries/reports"

const REPORT_TYPES = {
	cmi: true,
	hecla_weekly: true,
} as const satisfies Record<ReportType, true>

function isReportType(value: string): value is ReportType {
	return value in REPORT_TYPES
}

export const Route = createFileRoute("/_authenticated/mail/$slug")({
	component: TopicDetailRoute,
})

function TopicDetailRoute() {
	const { slug } = Route.useParams()
	if (!isReportType(slug)) return <NotFound />
	return <TopicDetail slug={slug} />
}

function TopicDetail({ slug }: { slug: ReportType }) {
	const { data: descriptor, isLoading, error } = useReport(slug)

	if (error instanceof ApiError && error.status === 404) return <NotFound />
	if (error) throw error

	return (
		<Layout>
			{isLoading || !descriptor ? (
				<TopicDetailSkeleton />
			) : (
				<TopicDetailPage descriptor={descriptor} />
			)}
		</Layout>
	)
}
